import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Button } from '@skunexus/component-catalog';

import styles from './styles.module.css';

function CreatePO({ createPOPoRoute }) {
    const { push } = useHistory();

    return (
        <div className={styles.wrapper}>
            <Button onClick={() => push(createPOPoRoute)} color="primary" className={styles.continueButton}>
                Continue
            </Button>
        </div>
    );
}
CreatePO.propTypes = {
    createPOPoRoute: PropTypes.string.isRequired,
};

CreatePO.defaultProps = {};

export default CreatePO;
